import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { Designation } from '../store/designation/designation.state'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class DesignationService {
  private apiUrl = eps.company.designationApi

  constructor(private http: HttpClient) {}

  getDesignations(params?: string | null, page?: number, limit?: number): Observable<any> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<any>(url)
  }

  blockDesignation(designationId: string, status: boolean): Observable<any> {
    return this.http.put(`${this.apiUrl}/block/${designationId}`, { disabled: status })
  }

  deleteDesignation(designationId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${designationId}`, {})
  }

  createDesignation(designation: {
    designationName: string
    departmentId: string
    businessId: string
  }): Observable<Designation> {
    return this.http.post<Designation>(`${this.apiUrl}`, designation)
  }

  updateDesignation(designation: {
    id: string
    designationName: string
    departmentId: string
    businessId: string
  }): Observable<Designation> {
    return this.http.put<Designation>(`${this.apiUrl}/${designation.id}`, designation)
  }
}
